<app-public-menu></app-public-menu>
<div class="content-router">
  <router-outlet></router-outlet>
</div>
<app-banner-lgpd></app-banner-lgpd>
<app-footer></app-footer>

<!-- Toasts gerais da área logada. -->
<ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.class" [autohide]="true"
  [delay]="toast.delay || 5000" (hide)="toastService.remove(toast)">{{ toast.body }}</ngb-toast>